import { render } from "./FormPainterComponent.vue?vue&type=template&id=11ae7606"
import script from "./FormPainterComponent.vue?vue&type=script&lang=js"
export * from "./FormPainterComponent.vue?vue&type=script&lang=js"

import "./FormPainterComponent.vue?vue&type=style&index=0&id=11ae7606&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__